import { startCase } from "lodash";

export const convertString = (stringValue, type) => {
  if (stringValue) {
    return type
      ? type === "startCase"
        ? startCase(stringValue.toLowerCase())
        : stringValue.toUpperCase()
      : stringValue.toLowerCase();
  }
};

export const getDesiredStatePolicyRequest = (filter, desiredStatePolicy) => {
  let payload = {};
  const processedRule = [];
  let policyType = Array.isArray(desiredStatePolicy.desiredStatePolicyType)
    ? desiredStatePolicy.desiredStatePolicyType[0]
    : desiredStatePolicy.desiredStatePolicyType;
  desiredStatePolicy.desiredStateRuleList.forEach((rules) => {
    processedRule.push({
      ComplianceSeverity: convertString(rules.complianceSeverity, true),
      RuleName: rules.ruleName,
      RuleId: rules.ruleId,
      RuleType: rules.ruleType,
      Platform: rules.platform,
      Remediation: rules.Remediation,
      Type: rules.Type,
      Parameters: rules.Parameters,
      desiredStateRuleFilesCheck: rules.desiredStateRuleFilesCheck,
      desiredStateRuleWindowsRegistry: rules.desiredStateRuleWindowsRegistry,
      parameterMetaData: rules.parameterMetaData,
      remediationEnabled: rules.remediationEnabled,
      windowsScript: rules.windowsScript,
      remediationScript: rules.remediationScript,
      switchDssRuleOs: rules.switchDssRuleOs,
    });
  });
  //Description, Name, Type
  payload.Description = desiredStatePolicy.desiredStatePolicyDescription;
  payload.Name = desiredStatePolicy.desiredStatePolicyName;
  payload.Type = policyType;
  payload.ID = desiredStatePolicy.desiredStatePolicyId;
  payload.Rules = processedRule;
  payload.Orgs = filter.Orgs;
  payload.Depts = filter.Depts;
  return payload;
};

export const getDesiredStatePolicyDetails = (desiredStatePolicy) => {
  const processedData = {};
  const processedRule = [];
  desiredStatePolicy.Rules.forEach((rules) => {
    processedRule.push({
      desiredStateRuleFilesCheck: rules.desiredStateRuleFilesCheck,
      desiredStateRuleWindowsRegistry: rules.desiredStateRuleWindowsRegistry,
      ruleName: rules.RuleName,
      ruleType: rules.RuleType,
      ruleId: rules.RuleId,
      platform: rules.Platform,
      complianceSeverity: convertString(rules.ComplianceSeverity, "startCase"),
      Parameters: rules.Parameters,
      parameterMetaData: rules.parameterMetaData,
      Type: rules.Type,
      Remediation: rules.Remediation,
      remediationEnabled: rules.remediationEnabled,
      windowsScript: rules.windowsScript,
      remediationScript: rules.remediationScript,
      switchDssRuleOs: rules.switchDssRuleOs,
    });
  });

  // Description, Name, Type
  processedData.DesiredStatePolicyDescription = desiredStatePolicy.Description;
  processedData.DesiredStatePolicyID = desiredStatePolicy.ID;
  processedData.DesiredStatePolicyName = desiredStatePolicy.Name;
  processedData.DesiredStatePolicyType = desiredStatePolicy.Type;
  processedData.DesiredStateRule = processedRule;
  return processedData;
};
